import { Component, OnInit,ViewChild,ElementRef,DoCheck} from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog} from '@angular/material';
import {SelectionModel} from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';


export interface PeriodicElement {
  //position:number;
  ID: string;
  CODGASTO: string;
  FORMAPAGO: string;
  FECHAPAGO: string;
  IMPORTE: string;
  OBSERVACIONES: string;
  CODOPERA: string;
  CODCONCEPTO: string;
  CODFONDO: string;
  TIPOPAGOGASTO: string;
  IDUSER: string;
  IDSEC: string;
  SECCIONAL: string;
}

var ELEMENT_DATA: PeriodicElement[] = [];

/**
 * @title Table with filtering
 */

@Component({
  selector: 'app-impresion-op',
  templateUrl: './impresion-op.component.html',
  styleUrls: ['./impresion-op.component.css']
})

export class ImpresionOpComponent implements OnInit, DoCheck {
  codpag;
  est;
  detalleGasto;
  secdet;
  moti;
  detmoti;
  secc;
  user;
  feccarga;
  loading;
  cuentaBanco;
  descCuentaBanco;
  nroOpera;
  sumatoria;
  FONDOS;
  @ViewChild('TABLE') table: ElementRef;
  displayedColumns: string[] = ['ID', 'CODGASTO', 'FECHAPAGO', 'OBSERVACIONES', 'IMPORTE'];

  dataSource = new MatTableDataSource(ELEMENT_DATA);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selection = new SelectionModel<PeriodicElement>(true, []);

  constructor(private http: HttpClient,public snackBar: MatSnackBar) {this.loading=true;}

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Si el número de elementos seleccionados coincide con el número total de filas..
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  ngOnInit() {
    window.scroll(0,0);    
    this.codpag= localStorage.getItem('codpag_edit');
    console.log(this.codpag);
    if (this.codpag != null){
      this.cargaGrid();
    }else{
      console.warn("NO HAY NUMERO DE ORDEN DE PAGO A CARGAR..");
    }
    
  }
  
  TIENEFONDOS = false;
  ngDoCheck(){
    if (this.dataSource.data.length >0){
      if (this.FONDOS >= 1){
        this.TIENEFONDOS = true;
        console.log("Fondo: " + this.FONDOS);
      }else{
        this.TIENEFONDOS = false;
        console.log("NO TIENE FONDO")
      }
    }
  }

  opagotruco;
  detpa;
  registros = 0;
  cargaGrid(){
    this.http.get(`${environment.backendUrl}/api/impresion-op/get2OK?codpag=${this.codpag}`)
    .subscribe((data: any[]) => {
      if (data && data.length!=0){
        this.dataSource.data = data; 
        console.warn(this.dataSource.data);
        this.codpag = this.dataSource.data[0]["ID"];
        this.user = this.dataSource.data[0]["IDUSER"];
        this.secc = this.dataSource.data[0]["SECCIONAL"];
        this.moti = this.dataSource.data[0]["TIPOPAGOGASTO"];
        this.detmoti = this.dataSource.data[0]["OBSERVACIONES"];
        this.feccarga = this.dataSource.data[0]["FECHAPAGO"];
        this.est = this.dataSource.data[0]["CODFONDO"];
        this.cuentaBanco = this.dataSource.data[0]["CODCONCEPTO"];
        this.detpa = this.dataSource.data[0]["DETALLE"];
        this.FONDOS = this.dataSource.data[0]["FONDO"];
        switch(this.cuentaBanco) { 
          case '111400': { 
             this.descCuentaBanco = 'BANCO NACION TRANSFERENCIA';
             break; 
          } 
          case '111402': { 
            this.descCuentaBanco = 'BANCO ITAU TRANSFERENCIA';
             break; 
          } 
          case '111401': { 
            this.descCuentaBanco = 'BANCO NACION CTA.CTE.';
             break; 
          }
          case '111403': { 
            this.descCuentaBanco = 'BANCO ITAU CTA.CTE.';
             break; 
          }
        }
        this.nroOpera = this.dataSource.data[0]["CODOPERA"];
        var sumi = 0;
        for (var _i = 0; _i < this.dataSource.data.length; _i++) {
          sumi = sumi + parseFloat(this.dataSource.data[_i]["IMPORTE"]);
        }
        this.sumatoria = sumi;
        this.loading=false; 
        this.snackBar.open('ORDEN DE PAGO ' + this.codpag +' CARGADA!', 'Cerrar', {duration: 2000});
        console.log(`${this.dataSource.data.length} ITEMS`);
        this.registros = this.dataSource.data.length;
      }else{
        console.log("request sin datos..");
        this.snackBar.open('NO SE ENCONTRO OP NRO:' + this.codpag +'!', 'Cerrar', {duration: 2000});
        this.loading=false;
      }
    });
  }

  cargaGridTruco(){
    this.loading=true;
    this.http.get(`${environment.backendUrl}/api/impresion-op/get2OK?codpag=${this.opagotruco}`)
    .subscribe((data: any[]) => {
      if (data && data.length!=0){
        this.dataSource.data = data; 
      console.warn(this.dataSource.data);
      this.codpag = this.dataSource.data[0]["ID"];
      this.user = this.dataSource.data[0]["IDUSER"];
      this.secc = this.dataSource.data[0]["SECCIONAL"];
      this.moti = this.dataSource.data[0]["TIPOPAGOGASTO"];
      this.detmoti = this.dataSource.data[0]["OBSERVACIONES"];
      this.feccarga = this.dataSource.data[0]["FECHAPAGO"];
      this.est = this.dataSource.data[0]["CODFONDO"];
      this.cuentaBanco = this.dataSource.data[0]["CODCONCEPTO"];
      this.detpa = this.dataSource.data[0]["DETALLE"];
      this.FONDOS = this.dataSource.data[0]["FONDO"];
      switch(this.cuentaBanco) { 
        case '111400': { 
           this.descCuentaBanco = 'BANCO NACION TRANSFERENCIA';
           break; 
        } 
        case '111402': { 
          this.descCuentaBanco = 'BANCO ITAU TRANSFERENCIA';
           break; 
        } 
        case '111401': { 
          this.descCuentaBanco = 'BANCO NACION CTA.CTE.';
           break; 
        }
        case '111403': { 
          this.descCuentaBanco = 'BANCO ITAU CTA.CTE.';
           break; 
        }
      }
      this.nroOpera = this.dataSource.data[0]["CODOPERA"];
      var sumi = 0;
      for (var _i = 0; _i < this.dataSource.data.length; _i++) {
        sumi = sumi + parseFloat(this.dataSource.data[_i]["IMPORTE"]);
      }
      this.sumatoria = sumi;
      this.loading=false; 
      this.snackBar.open('ORDEN DE PAGO ' + this.opagotruco +' CARGADA!', 'Cerrar', {duration: 2000});
      console.log(`${this.dataSource.data.length} ITEMS`);
      this.registros = this.dataSource.data.length;
      document.getElementById("botontruco").click(); 
      }else{
        console.log("request sin datos..");
        this.snackBar.open('NO SE ENCONTRO OP NRO:' + this.opagotruco +'!', 'Cerrar', {duration: 2000});
        this.loading=false;
        document.getElementById("botontruco").click(); 
      }
    });
  }

  onPrint(){
    console.log("printitntin");
    window.print();
}

print2(){
  window.print();
}

print(): void {
  let printContents, popupWin;
  printContents = document.getElementById('print-section').innerHTML;
  popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
  popupWin.document.open();
  popupWin.document.write(`
    <html>
      <head>
        <title>Print tab</title>
        <style>
        //........Customized style.......
        </style>
      </head>
  <body onload="window.print();window.close()">${printContents}</body>
    </html>`
  );
  popupWin.document.close();
}

truco=0;
PAGUIN = false;
contar(){
  this.truco = this.truco + 1;
  if (this.truco >4){
    this.PAGUIN = true;
  }else{
    this.PAGUIN = false;
  }
  console.log("TRUCO: " +this.truco);  
}
ocultarTruco(){
  this.PAGUIN=false;
  this.truco=0;
}

}
